import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import Carousel from 'LuxKit/Carousel/Carousel'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'

interface Props {
  breakfastIncluded: boolean
  freeCancellation: boolean
}

function PropertyQuickFilters({ breakfastIncluded, freeCancellation }: Props) {
  const intl = useIntl()
  const offerPageDispatch = useOfferPageDispatch()

  const breakfastIncludedLabel = intl.formatMessage({
    id: 'w2jEyEHf_MDWoniUCBnT',
    defaultMessage: 'Breakfast included',
    description: 'Label for togglable filter chip that restricts displayed hotel rates to those with breakfast included',
  })
  const freeCancellationLabel = intl.formatMessage({
    id: 'Cnk7NVK8VWdi1ubUWdxY',
    defaultMessage: 'Free cancellation',
    description: 'Label for togglable filter chip that restricts displayed hotel rates to those with free cancellation',
  })

  const toggleBreakfastIncluded = useCallback(() => {
    offerPageDispatch({
      type: OfferPageActions.setQuickFilters,
      quickFilters: { breakfastIncluded: !breakfastIncluded },
    })
  }, [breakfastIncluded, offerPageDispatch])
  const toggleFreeCancellation = useCallback(() => {
    offerPageDispatch({
      type: OfferPageActions.setQuickFilters,
      quickFilters: { freeCancellation: !freeCancellation },
    })
  }, [freeCancellation, offerPageDispatch])

  return <Carousel gutterStyle="overflow" gap={8}>
    <FilterChip
      size="medium"
      selected={breakfastIncluded}
      startIcon={breakfastIncluded ? <LineCheckIcon /> : <LineCoffeeIcon />}
      onClick={toggleBreakfastIncluded}
    >
      {breakfastIncludedLabel}
    </FilterChip>
    <FilterChip
      size="medium"
      selected={freeCancellation}
      startIcon={freeCancellation ? <LineCheckIcon /> : <LineShieldCheckIcon />}
      onClick={toggleFreeCancellation}
    >
      {freeCancellationLabel}
    </FilterChip>
  </Carousel>
}

type MappedProps = Props

export default withOfferPageState((state): MappedProps => ({
  breakfastIncluded: !!state.quickFilters?.breakfastIncluded,
  freeCancellation: !!state.quickFilters?.freeCancellation,
}), PropertyQuickFilters)
